import React, { Component } from 'react';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';
import CustomSpinner from './CustomSpinner.js'
import LeadInfo from './LeadInfo.js';

class Congratulations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hash_id: null,
            provider_phone: null
        };
    }

     componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                const hash_id = data.operation_id === undefined ? data.id : data.operation_id;
                this.setState({ 'hash_id': hash_id });
            }
        );

        axios.get(`${ROOT_URL}/providers/lead`, config)
            .then(response => {
                const provider = response.data;
                this.setState({ 'provider_phone': provider.phone });
            }
        );

        axios.get(`${ROOT_URL}/leads/congratulations`, config);

    }

    render() {
        const { clientName } = this.props;

        return (
            <Section className="intro_form">
            <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                    <div className="header-img" >
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                    </div>
                    <div className="header-message">
                        <FormattedHTMLMessage id="app.step_congratulations" description="Congratulations info" values={{ nameClient: clientName, }}/>
                    </div>
                </div>
                <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                    {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                    <div className="pvc-container text-center">
                        <h3><b>En breve, te vamos a contactar a tu celular para una última verificación. Guardá el número de referencia de tu adelanto:</b></h3>
                        <h4 className="pd-hash-value">{ this.state.hash_id || "Cargando..." }</h4>
                        <h3><b>GRACIAS y DISFRUTÁ de tu Dinero</b></h3>
                    </div>
                </div>
            </div>
        </Section>
        );
    }
}

Congratulations = TopScrolleable(Congratulations);

Congratulations = LeadInfo(Congratulations);

Congratulations = withAuthControl(Congratulations);

export default Congratulations;



/** WEBPACK FOOTER **
 ** ./src/components/Congratulations.js
 **/